import ReactGa from "react-ga4";

export function giveConsent() {
    ReactGa.set({
        'analytics_storage': 'granted'
    })
}

export function initializeGa() {
    ReactGa.initialize("G-0P3PVM0D2N", {
        gaOptions: {
            allowAdFeatures: false,
            'ad_storage': 'denied',
            'ad_personalization': 'denied',
            'ad_user_data': 'denied',
            'analytics_storage': 'denied'
        }
    })
}

export function trackPageView(location) {
    ReactGa.send({
        hitType: 'pageview',
        page: location.pathname + location.search + location.hash
    });
}

export function trackClick(category, linkUrl) {
    ReactGa.event({
        category: category,
        action: "AClick",
        label: linkUrl
    })
}
